import React from 'react';
import { Colors } from '../../../data/Colors';
import { MeshProps } from '@react-three/fiber/dist/declarations/src/three-types';
import useUnitSphereGeometry from '../geometry/useUnitSphereGeometry';

const originSphereSize = 0.02;

export default function OriginSphere({ ...props }: MeshProps): JSX.Element
{
  const sphereGeom = useUnitSphereGeometry();
  return <mesh {...props} geometry={sphereGeom} scale={[ originSphereSize, originSphereSize, originSphereSize ]}>
    <meshBasicMaterial color={Colors.NeutralGrey} toneMapped={false}/>
  </mesh>;
}